export const MILLISECONDS_PER_SECOND = 1000;

export const DURATION_PER_QUESTION = 15; //SECOND UNIT
